import(/* webpackMode: "eager" */ "/app/src/app/[locale]/template.tsx");
